import React from 'react'
// import video_instructivo_concurso  from '../../assets/videos/Video Instructivo - Concurso Doctorados 2024.mp4'
// import ReactPlayer from 'react-player'
import baremoPdf from '../../assets/files/Concurso/Doctorados2025/BAREMO DOCTORADOS 2026.pdf'

const ConcursoDoctorados = () => {
  const programas = [
    {
      nombre: "Doctorado en Ciencias de la Salud",
      path: "/posgrado/doctorados/doctorado-ciencias-salud"
    },
    {
      nombre: "Doctorado en Ciencias Médicas",
      path: "/posgrado/doctorados/doctorado-ciencias-medicas"
    },
    {
      nombre: "Doctorado en Metabolismo Humano",
      path: "/posgrado/doctorados/doctorado-metabolismo-humano"
    }
  ];

  const baremo = {
    url: baremoPdf,
    fileName: 'BAREMO DOCTORADOS 2026'
  };

  const formInscripcionDoctorados = 'https://forms.gle/mwTZcQGB5xrpMAEq5'

  // const [videoReadyStatus, setVideoReadyStatus] = useState(false);
  
  // const toggleVideoStatus = () => {
  //   setVideoReadyStatus(true);
  //   // console.log('Video status: ' + videoReadyStatus)
  // }

  return (
    <div className='page-section instructivos doctorados'>
      {/* <section className='video-container'>
        <div className={`video-canvas ${videoReadyStatus ? 'ready' : 'loading'}`}>
          <button
            className={`video-placeholder btn btn-secondary disabled placeholder-wave d-${videoReadyStatus ? 'none' : 'block'}`}
          ></button>
          <div className={`d-${videoReadyStatus ? 'block' : 'none'}`}>
            <ReactPlayer
              className='video-player'
              url={video_instructivo_concurso}
              playing={true}
              volume={0.3}
              controls={true}
              width={'100%'}
              height={'auto'}
              onReady={toggleVideoStatus}
            />
          </div>
        </div>
      </section> */}

      <section className='info-container'>
        <div className='info-group mb-3'>
          <p className='intro-p'>La División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia, da inicio al Concurso 2026.</p>
        </div>

        <div className='info-group mb-4'>
          <h3 className='modal-subtitle fw-semibold mb-4'>Baremo</h3>
          <a 
            href={baremo.url} 
            download={baremo.fileName} 
            className='btn-baremo btn btn-primary link-button'
          >
            Descargar Baremo
          </a>
        </div>
        
        <div className='info-group d-flex flex-column mt-3'>
          <h3 className='modal-subtitle mb-4'>Programas</h3>
          {
            programas.map((programa, index) =>
              <a key={index} href={programa.path} target='blank' className='info-p fw-semibold sublink'>
                {programa.nombre}
              </a>
            )
          }
        </div>
        <div className='info-group mb-0'>
          <div className='spaced-lg'>
            <p className='fw-bold mb-1'>Apertura del Concurso: </p>
            <p>13 de abril de 2026</p>
          </div>
          <div className='spaced-lg'>
            <p className='fw-bold mb-1'>Recepción de Credenciales: </p>
            <p>13 de abril al 30 de septiembre de 2026</p>
          </div>
          {/* <div className='spaced-lg'>
            <p className='fw-semibold mb-1'>Entrevista: </p>
            <p>19/01 al 30/01/2026</p>
          </div>
          <div className='spaced-lg'>
            <p className='fw-semibold mb-1'>Publicación de Resultados: </p>
            <p>02/02 al 06/02/2026</p>
          </div> */}
          <div className='spaced-lg'>
            <p className='fw-bold mb-1'>Inicio de Clases: </p>
            <p className='fw-normal'>02 de marzo de 2027</p>
          </div>
          <div>
            <p className='fw-bold'>Formulario de Inscripción: </p>
            <a 
              href={formInscripcionDoctorados}
              target='blank'
              className='btn-baremo btn btn-primary link-button'
            >
              Ir al formulario
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export { ConcursoDoctorados }